export default __webpack_public_path__ + "static/media/icon-alert-error.b20571c2.svg";